export default __webpack_public_path__ + "assets/img/redeem-access_enter-code@1x.png";